import axios, { apiBaseURL } from './axios'

const trustedByBaseURL = `${apiBaseURL}/companies`

export default class TrustedByApi {
  static getTrustedBy(): Promise<ITrustedBy> {
    return axios.get(`${trustedByBaseURL}/get-trusted-by-companies`)
  }
}
